import { render } from "./QCheckBox.vue?vue&type=template&id=0bd33a85"
import script from "./QCheckBox.vue?vue&type=script&lang=ts"
export * from "./QCheckBox.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
